<template>
  <router-link :to="link">
    <div class="app-button">
      <div class="app-button-icon-area">
        <i :class="[iconStyle, icon, 'fa-fw']"></i>
      </div>
      <div class="app-button-main-area">
        <slot />
      </div>
    </div>
  </router-link>
</template>

<style scoped>
.app-button {
  min-height: 40px;
  display: flex;
  background-color: #FAFAFB;
  border: 1px solid #e7eaec;
  border-radius: 2px;
}
.app-button-icon-area {
  flex-basis: 40px;
  line-height: 40px;
  vertical-align: middle;
  text-align: center;
  border-radius: 4px;
  margin: 5px;
}
.app-button-icon-area i {
  font-size: 2rem;
}
.app-button-main-area {
  flex: 1;
  padding: 4px;
}
</style>

<script>
export default {
  name: 'AppButton',
  props: {
    iconStyle: {
      type: String,
      default: 'fas',
    },
    icon: {
      type: String,
      default: 'fa-cog',
    },
    link: String
  }
}
</script>